<template>
  <b-modal
    :id="MODAL_ID"
    v-model="isVisible"
    size="md"
    centered
    hide-header
    hide-footer
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </b-modal>
</template>

<script>
// utils
import { generateRandomString } from "@/utils/string";

// libs
import _ from "lodash";

// constants
const MODAL_ID = `modal-${generateRandomString()}`;

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      MODAL_ID: MODAL_ID,
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    onModalShow() {
      console.log("shown");
    },
  },
};
</script>

<style lang="scss" scoped></style>
